// extracted by mini-css-extract-plugin
export default {"container":"PresenceAvatarStack-module__container--sFz+e","avatar":"PresenceAvatarStack-module__avatar--ucuoe"};